var render, staticRenderFns
import script from "./AddNodeBtn.vue?vue&type=script&lang=js"
export * from "./AddNodeBtn.vue?vue&type=script&lang=js"
import style0 from "./AddNodeBtn.vue?vue&type=style&index=0&id=2076d29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076d29a",
  null
  
)

export default component.exports